import { PrefetchLink } from "@/components/routing/PrefetchLink";
import { Text } from "@mantine/core";
import styles from "./styles/LatestPodcasts.module.css";
import { ImageSizes } from "@/core/helpers";
import { CoverImage } from "@/components/podcast/CoverImage";

export function PopularPodcasts({ podcasts }: { podcasts: Podcast[] | undefined }) {
    if (!podcasts) {
        return null;
    }
    return (
        <ul className={styles.list}>
            {podcasts.map((podcast) => (
                <li key={`popular-podcast-${podcast.id}`}>
                    <PrefetchLink className={styles.row} to={`/podd/${podcast.slug}`}>
                        <CoverImage podcast={podcast} size={ImageSizes.Thumb} />
                        <span className={styles.text}>
                            <Text fw={600} lineClamp={1}>
                                {podcast.name}
                            </Text>
                            <Text c="dimmed" lineClamp={1} size="sm">
                                {podcast.author.name}
                            </Text>
                        </span>
                    </PrefetchLink>
                </li>
            ))}
        </ul>
    );
}
